// Image slider for collection cards: native scroll-snap handles touch swipe,
// this adds dot navigation and mouse drag on desktop.
// ponytail: no loop mode, the track stops at the first/last image.
if (!customElements.get('card-slider')) {
  customElements.define(
    'card-slider',
    class CardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.collection-card__track');
        this.dots = [...this.querySelectorAll('.collection-card__dot')];
        if (!this.track || this.dots.length < 2) return;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
        this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
        this.track.addEventListener('pointerdown', (event) => this.startDrag(event));
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        // A drag must not open the product page
        this.track.addEventListener(
          'click',
          (event) => {
            if (!this.dragged) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
      }

      get index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      // Element scrollTo({ behavior: 'smooth' }) does nothing on this site (a theme script interferes),
      // so smoothness comes from the track's CSS scroll-behavior instead
      goTo(index) {
        this.track.scrollLeft = index * this.track.clientWidth;
      }

      updateDots() {
        const active = this.index;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      }

      startDrag(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        const startX = event.clientX;
        const startLeft = this.track.scrollLeft;
        const startIndex = this.index;
        this.dragged = false;
        clearTimeout(this.snapTimer);

        const onMove = (moveEvent) => {
          const dx = moveEvent.clientX - startX;
          if (!this.dragged && Math.abs(dx) < 5) return;
          if (!this.dragged) {
            this.dragged = true;
            this.track.classList.add('is-dragging');
          }
          this.track.scrollLeft = startLeft - dx;
        };

        const onUp = (upEvent) => {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          if (!this.dragged) return;

          const dx = upEvent.clientX - startX;
          const step = Math.abs(dx) > this.track.clientWidth * 0.15 ? Math.sign(-dx) : 0;
          const target = Math.max(0, Math.min(this.dots.length - 1, startIndex + step));
          // Snapping stays off until the smooth scroll settles, otherwise it fights the animation
          this.track.classList.replace('is-dragging', 'is-settling');
          this.goTo(target);
          this.snapTimer = setTimeout(() => this.track.classList.remove('is-settling'), 500);
          // The click event fires right after pointerup; reset once it has been swallowed
          setTimeout(() => (this.dragged = false));
        };

        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
      }
    }
  );
}
